module.exports = __webpack_public_path__ + "static/media/givesounds-3-fix.73923b7d.jpg";